import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import FormLayout from 'src/layouts/form';
// components
import { LoadingScreen } from 'src/components/loading-screen';
// ----------------------------------------------------------------------

const DashboardLayoutStore = lazy(() =>
  import('src/layouts/dashboard/layout').then((module) => ({ default: module.DashboardLayoutStore }))
);

const UserSettings = lazy(() => import('src/pages/user/userSettings'));
const InvoiceDetailsView = lazy(() => import('src/pages/invoice/view/invoice-details-view'));


// ----------------------------------------------------------------------

export const SettingsOrgRoutes = [
  {
    path: 'settings',
    element: (
      <AuthGuard allowedRoles={['organization']}>
        <DashboardLayoutStore>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayoutStore>
      </AuthGuard>
    ),
    children: [
      { element: <UserSettings />, index: true },
      { path: 'invoice', element: <InvoiceDetailsView /> },
    ],
  },
];

